import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 30 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m3.147 1.254 24.124 25.35.724-.689-3.33-3.499a7.294 7.294 0 0 0-.606-13.971A9.118 9.118 0 0 0 8.25 5.164L3.872.564l-.725.69Zm5.797 4.64 14.95 15.711a6.294 6.294 0 0 0-.076-12.19l-.562-.14-.158-.556A8.118 8.118 0 0 0 8.944 5.894ZM7.522 8.606c.117-.39.263-.769.436-1.132l-.733-.77a9.056 9.056 0 0 0-.661 1.614 7.293 7.293 0 0 0 1.145 14.493H22.29c.086 0 .172-.001.257-.004l-.947-.995H7.709a6.291 6.291 0 0 1-.99-12.506l.622-.098.18-.602Z"
      fill="#fff"
    />
  </svg>
);
const Memo = memo(SvgError);
export default Memo;
